import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import "./add-pricing-equipment-template.scss";
import {
    SaveUpdatePricingEquipmentTemplate,
    GetEquipmentTemplate,
    getTemplateList,
    GetMccList,
    getAllEmsOffices,
} from "../../../api";
import Loader from "../../loader/loader";
import SelectDropDown from "../../shared/drop-down/drop-down";

import * as yup from "yup";
const schema = yup.object({
    pricing_template_id: yup
        .string()
        .trim()
        .required("* Pricing template is required"),
    equipment_template_id: yup
        .string()
        .trim()
        .required("* Equipment template is required"),
    template_name: yup.string().trim().required("* Template name is required"),
});
class AddTemplateModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedTemplate ? true : false,
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            formData: {
                pricing_template_id: props.selectedTemplate
                    ? props.selectedTemplate.pricing_template_id
                    : "",
                equipment_template_id: props.selectedTemplate
                    ? props.selectedTemplate.equipment_template_id
                    : "",
                template_name: props.selectedTemplate
                    ? props.selectedTemplate.template_name
                    : "",
                tms_template_id: props.selectedTemplate
                    ? props.selectedTemplate.tms_template_id
                    : "",
                mcc_code: props.selectedTemplate
                    ? props.selectedTemplate.mcc_id
                    : "",
                ems_office: props.selectedTemplate
                    ? props.selectedTemplate.ems_office
                    : "",
            },
            errors: [],
            pricingTemplates: [],
            equipmentTemplates: [],
            mccList: [],
            emsOffices: [],
        };
    }
    componentDidMount() {
        this.getPricingTemplates();
        this.getEquipmentTemplates();
        this.getMccData();
        getAllEmsOffices().then((res) => {
            let emsOfficesListTemp = [];
            let emsOfficesListDefault = [
                {
                    value: "",
                    label: "Select",
                },
            ];
            emsOfficesListTemp = [...emsOfficesListDefault, ...res.data];
            this.setState({ emsOffices: emsOfficesListTemp });
        });
    }
    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;

        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }
    handleRoleChange(event) {
        let formData = this.state.formData;
        formData["role"] = event.value;
        this.setState({ formData: formData });
    }
    // add organization data
    handleAddTemplate(evt) {
        this.setState({ show_spinner: true });

        const fromData = this.state.formData;

        if (fromData.ems_office == "" && this.props?.user?.is_ems_user) {
            this.setState({
                show_spinner: false,
                errorMessage: "*EMS Office ID is required",
            });
            return;
        }

        const postData = {
            id: this.state.isEdit ? this.props.selectedTemplate.id : null,
            pricing_template_id: fromData.pricing_template_id,
            equipment_template_id: fromData.equipment_template_id,
            template_name: fromData.template_name,
            organization_id: this.state.isEdit
                ? this.props.selectedTemplate.organization_id
                : this.props.organization_id,
            tms_template_id: fromData.tms_template_id,
            user_id: this.state.isEdit
                ? this.props.selectedTemplate.user_id
                : this.props.selected_user_id,
            mcc_id: fromData.mcc_code,
            ems_office: fromData.ems_office,
        };
        SaveUpdatePricingEquipmentTemplate(postData)
            .then((res) => {
                if (res.success) {
                    this.props.handleCloseModel();
                    this.props.GetTemplateList();
                } else {
                    this.setState({
                        show_spinner: false,
                        errorMessage: "Something wrong please try again.",
                    });
                }
            })
            .catch((err) => {
                if (err.status === 422) {
                    this.setState({
                        show_spinner: false,
                        errorMessage:
                            "Validation error! Please fill all required fields",
                    });
                } else {
                    this.setState({
                        show_spinner: false,
                        errorMessage: "Something wrong please try again.",
                    });
                }
            });
    }

    getPricingTemplates() {
        const tempoption = this.props.pricingTemplateList.map((t) => {
            return {
                value: t.id,
                label: t.pricing_template_name,
            };
        });
        this.setState({ pricingTemplates: tempoption });
    }
    getEquipmentTemplates() {
        const tempoption = this.props.equipmentTemplateList.map((t) => {
            return {
                value: t.id,
                label: t.template_name,
            };
        });
        this.setState({ equipmentTemplates: tempoption });
    }
    handleEquipmentOptionChange(template) {
        const formData = this.state.formData;
        formData["equipment_template_id"] = template.value;
        this.setState({ formData: formData });
    }
    handlePricingOptionChange(template) {
        const formData = this.state.formData;
        formData["pricing_template_id"] = template.value;
        this.setState({ formData: formData });
    }
    handleMccOptionChange(selected) {
        const formData = this.state.formData;
        formData["mcc_code"] = selected.value;
        this.setState({ formData: formData });
    }
    handleEMSOfficeChange(selected) {
        const formData = this.state.formData;
        formData["ems_office"] = selected.value;
        this.setState({ formData: formData, errorMessage: "" });
    }

    getMccData() {
        const payload = {};
        GetMccList(payload)
            .then((response) => {
                if (response.success === true) {
                    const mccOption = response.data.map((t) => {
                        return {
                            value: t.id,
                            label: t.description,
                        };
                    });
                    this.setState({ mccList: mccOption }, () =>
                        this.setState({ show_spinner: false }),
                    );
                } else {
                    this.setState({ show_spinner: false });
                }
            })
            .catch((error) => console.log(error));
    }

    render() {
        const {
            isEdit,
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
        } = this.state;
        return (
            <ReactModal isOpen={this.props.show} className="add-template-modal">
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit Template" : "Add Template"}
                    </h4>
                </div>
                <div
                    onClick={() => this.props.handleCloseModel()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleAddTemplate(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="add-template-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <SelectDropDown
                                            options={
                                                this.state.pricingTemplates
                                            }
                                            name="pricing_template_id"
                                            placeholder="Select Pricing Template"
                                            value={values.pricing_template_id}
                                            handleChange={(selected) => {
                                                values.pricing_template_id =
                                                    selected.value;
                                                this.handlePricingOptionChange(
                                                    selected,
                                                );
                                                errors.pricing_template_id = "";
                                            }}
                                            touched={
                                                touched.pricing_template_id
                                            }
                                            errors={errors.pricing_template_id}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Pricing Template
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.pricing_template_id}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <SelectDropDown
                                            options={
                                                this.state.equipmentTemplates
                                            }
                                            name="equipment_template_id"
                                            placeholder="Select Equipment Template"
                                            value={values.equipment_template_id}
                                            handleChange={(selected) => {
                                                values.equipment_template_id =
                                                    selected.value;
                                                this.handleEquipmentOptionChange(
                                                    selected,
                                                );
                                                errors.equipment_template_id =
                                                    "";
                                            }}
                                            touched={
                                                touched.equipment_template_id
                                            }
                                            errors={
                                                errors.equipment_template_id
                                            }
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Equipment Template
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.equipment_template_id}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Template Name"
                                            type="text"
                                            name="template_name"
                                            value={
                                                values.template_name
                                                    ? values.template_name
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.template_name &&
                                                !!errors.template_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.template_name
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            Template Name
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.template_name}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="TMS Template ID"
                                            type="text"
                                            name="tms_template_id"
                                            value={
                                                values.tms_template_id
                                                    ? values.tms_template_id
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.tms_template_id &&
                                                !!errors.tms_template_id
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.tms_template_id
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            TMS Template ID
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.tms_template_id}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <SelectDropDown
                                            options={this.state.mccList}
                                            name="mcc_code"
                                            placeholder="Select MCC"
                                            value={values.mcc_code}
                                            handleChange={(selected) => {
                                                values.mcc_code =
                                                    selected.value;
                                                this.handleMccOptionChange(
                                                    selected,
                                                );
                                                errors.mcc_code = "";
                                            }}
                                            touched={touched.mcc_code}
                                            errors={errors.mcc_code}
                                            is_submitted={is_submitted}
                                            isSearchable={true}
                                        />
                                        <label className="modal-lab">
                                            MCC Code
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.mcc_code}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <SelectDropDown
                                            options={this.state.emsOffices}
                                            name="ems_office"
                                            placeholder="EMS Office ID"
                                            value={values.ems_office}
                                            handleChange={(selected) => {
                                                values.ems_office =
                                                    selected.value;
                                                this.handleEMSOfficeChange(
                                                    selected,
                                                );
                                                errors.ems_office = "";
                                            }}
                                            touched={touched.ems_office}
                                            errors={errors.ems_office}
                                            is_submitted={is_submitted}
                                            isSearchable={true}
                                        />
                                        <label className="modal-lab">
                                            EMS Office ID
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.ems_office}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message text-center">{errorMessage}</p>
                <div className="modal-footer">
                    <div className="button-twoc">
                        <button
                            form="add-template-form"
                            type="submit"
                            className="btn confirm-button"
                        >
                            {" "}
                            {isEdit ? "Update" : "Add"}{" "}
                        </button>
                        <button
                            className="btn cancel-button"
                            onClick={() => this.props.handleCloseModel()}
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default AddTemplateModal;
